// import React from 'react';
// import { Field } from 'formik';
// import { TextField, Chip, MenuItem, Select, FormControl, InputLabel, Box, Grid, Typography } from '@mui/material';

// const PumpFormFields = ({ errors, touched, disabledFields = [] }) => {
//   return (
//     <div className="space-y-6">
//       <Field
//         as={TextField}
//         name="name"
//         label="Pump Name"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.name && !!errors.name}
//         helperText={touched.name && errors.name}
//       />
//       <Field
//         as={TextField}
//         name="imei"
//         label="IMEI (15 digits)"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         disabled={disabledFields.includes('imei')}
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.imei && !!errors.imei}
//         helperText={touched.imei && errors.imei}
//       />
//       <Field
//         as={TextField}
//         name="model_number"
//         label="Model Number"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.model_number && !!errors.model_number}
//         helperText={touched.model_number && errors.model_number}
//       />
//       <Field
//         as={TextField}
//         name="serial_number"
//         label="Serial Number"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.serial_number && !!errors.serial_number}
//         helperText={touched.serial_number && errors.serial_number}
//       />
//        <Field
//         as={TextField}
//         name="manufacturer"
//         label="Make"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.manufacturer && !!errors.manufacturer}
//         helperText={touched.manufacturer && errors.manufacturer}
//       />

// <FormControl fullWidth margin="normal" error={touched.panel_number_list && !!errors.panel_no_list}>
//   <InputLabel 
//     shrink 
//     sx={{
//       fontSize: '1.2rem',
//       '&.Mui-focused': {
//         fontSize: '1.2rem',
//         color: '#1976d2',
//       },
//       marginTop: '-10px'
//     }}
//   >
//     Panel Number
//   </InputLabel>
  
//   {/* Input field for adding new panel numbers */}
//   <Box sx={{ display: 'flex', gap: 1, mt: 2, alignItems: 'center' }}>
//     <TextField
//       value={currentInput}
//       onChange={(e) => setCurrentInput(e.target.value)}
//       onKeyPress={(e) => {
//         if (e.key === 'Enter') {
//           e.preventDefault();
//           if (currentInput.trim() && !values.panel_no_list?.includes(currentInput.trim())) {
//             setFieldValue('panel_no_list', [...(values.panel_no_list || []), currentInput.trim()]);
//             setCurrentInput('');
//           }
//         }
//       }}
//       placeholder="Enter panel number"
//       variant="outlined"
//       size="small"
//       sx={{ flexGrow: 1 }}
//     />
//     <Button
//       variant="contained"
//       onClick={() => {
//         if (currentInput.trim() && !values.panel_no_list?.includes(currentInput.trim())) {
//           setFieldValue('panel_no_list', [...(values.panel_no_list || []), currentInput.trim()]);
//           setCurrentInput('');
//         }
//       }}
//       disabled={!currentInput.trim() || values.panel_no_list?.includes(currentInput.trim())}
//       startIcon={<AddIcon />}
//     >
//       Add
//     </Button>
//   </Box>

//   {/* Display added panel numbers */}
//   {values.panel_no_list && values.panel_no_list.length > 0 && (
//     <Box sx={{ mt: 2 }}>
//       <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
//         Added Panel Numbers ({values.panel_no_list.length}):
//       </Typography>
//       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//         {values.panel_no_list.map((panelNumber, index) => (
//           <Chip
//             key={`${panelNumber}-${index}`}
//             label={panelNumber}
//             onDelete={() => {
//               const updatedList = values.panel_no_list.filter((_, i) => i !== index);
//               setFieldValue('panel_no_list', updatedList);
//             }}
//             deleteIcon={<DeleteIcon />}
//             variant="outlined"
//           />
//         ))}
//       </Box>
//       <Button
//         variant="text"
//         color="error"
//         size="small"
//         onClick={() => setFieldValue('panel_no_list', [])}
//         sx={{ mt: 1, textTransform: 'none' }}
//       >
//         Clear All
//       </Button>
//     </Box>
//   )}

//   {touched.panel_no_list && errors.panel_no_list && (
//     <Typography variant="caption" color="error" sx={{ mt: 1, fontSize: '0.75rem' }}>
//       {errors.panel_no_list}
//     </Typography>
//   )}
// </FormControl>



//       <Field
//         as={TextField}
//         name="rating"
//         label="Rating (HP)"
        
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.rating && !!errors.rating}
//         helperText={touched.rating && errors.rating}
//       />
//       <Field
//         as={TextField}
//         name="sim_iccid"
//         label="SIM ICCID (19-20 digits)"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         InputLabelProps={{
//           shrink: true,
//           sx: {
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//           },
//         }}
//         InputProps={{
//           notched: true,
//           sx: {
//             '& .MuiOutlinedInput-notchedOutline legend': {
//               fontSize: '0.9rem',
//               width: 'max-content',
//             },
//           },
//         }}
//         error={touched.sim_iccid && !!errors.sim_iccid}
//         helperText={touched.sim_iccid && errors.sim_iccid}
//       />
//     </div>
//   );
// };

// export default PumpFormFields;










import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { TextField, Chip, MenuItem, Select, FormControl, InputLabel, Box, Grid, Typography, Button } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';

const PumpFormFields = ({ errors, touched, disabledFields = [] }) => {
  const [currentPanelInput, setCurrentPanelInput] = useState('');
  const { values, setFieldValue } = useFormikContext();

  const handleAddPanelNumber = () => {
    if (currentPanelInput.trim() && !values.panel_number_list?.includes(currentPanelInput.trim())) {
      const updatedList = [...(values.panel_number_list || []), currentPanelInput.trim()];
      setFieldValue('panel_number_list', updatedList);
      setCurrentPanelInput('');
    }
  };

  const handleRemovePanelNumber = (indexToRemove) => {
    const updatedList = values.panel_number_list.filter((_, index) => index !== indexToRemove);
    setFieldValue('panel_number_list', updatedList);
  };

  const handlePanelInputKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleAddPanelNumber();
    }
  };

  return (
    <div className="space-y-6">
      <Field
        as={TextField}
        name="name"
        label="Pump Name"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.name && !!errors.name}
        helperText={touched.name && errors.name}
      />
      <Field
        as={TextField}
        name="imei"
        label="IMEI (15 digits)"
        variant="outlined"
        fullWidth
        margin="normal"
        disabled={disabledFields.includes('imei')}
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.imei && !!errors.imei}
        helperText={touched.imei && errors.imei}
      />
      <Field
        as={TextField}
        name="model_number"
        label="Model Number"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.model_number && !!errors.model_number}
        helperText={touched.model_number && errors.model_number}
      />
      <Field
        as={TextField}
        name="serial_number"
        label="Serial Number"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.serial_number && !!errors.serial_number}
        helperText={touched.serial_number && errors.serial_number}
      />
       <Field
        as={TextField}
        name="manufacturer"
        label="Make"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.manufacturer && !!errors.manufacturer}
        helperText={touched.manufacturer && errors.manufacturer}
      />

       <Field
        as={TextField}
        name="rating"
        label="Rating (HP)"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.rating && !!errors.rating}
        helperText={touched.rating && errors.rating}
      />

   
     
        <Field
        as={TextField}
        name="controller_number"
        label="Controller Number"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.controller_number && !!errors.controller_number}
        helperText={touched.controller_number && errors.controller_number}
      />
      <Field
        as={TextField}
        name="sim_iccid"
        label="SIM ICCID (19-20 digits)"
        variant="outlined"
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: '1.2rem',
            '&.Mui-focused': {
              fontSize: '1.2rem',
              color: '#1976d2',
            },
          },
        }}
        InputProps={{
          notched: true,
          sx: {
            '& .MuiOutlinedInput-notchedOutline legend': {
              fontSize: '0.9rem',
              width: 'max-content',
            },
          },
        }}
        error={touched.sim_iccid && !!errors.sim_iccid}
        helperText={touched.sim_iccid && errors.sim_iccid}
      />
    </div>
  );
};

export default PumpFormFields;



